/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Schema for the processing status of a DIDComm message attachment. It contains the attachment ID, media type, status, and optional error message.
 */
export interface DidCommMessageBlobAttachmentStatus {
    errorMessage?: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    id: string;
    mediaType: string;
    status: string;
}
